/* eslint-disable no-case-declarations */
export const mountFunnelChartData = ({ funis, obrasAtivas, tipo }) => {

  switch (tipo) {
    case "histograma-consumo":
      const { dates: histoDates, data: lines } = histograma({ obras: obrasAtivas });
      const { dates, data } = previstoConsumo({ funis });

      const column = data?.map(e => !isNaN(e) ? e / 100 : 0)

      return {
        dates,
        column,
        lines
      };
    case "negociacoes-futuras":
      const { dates: negociacoesDatas, data: negociacoesDados } = negociacoesFuturas({ funis });

      const negociacoesLines = [];
      const negociacoesColumn = [];

      Object.values(negociacoesDados).forEach(array => {
        let sum = 0;
        array.volumes.forEach(num => {
          sum += num;
        });
        negociacoesLines.push(sum);

        negociacoesColumn.push(array.itens.length);
      });

      return {
        dates: negociacoesDatas,
        column: negociacoesColumn,
        lines: negociacoesLines
      };
  }
}

const histograma = ({ obras }) => {
  return accByField({arrayData: obras, fieldName: "volumeContratado"})
};

const accByField = ({arrayData, fieldName}) => {
  let months = {};

  arrayData.forEach(item => {
    if(item.dataNegociacao) {
      const neg = new Date(item.dataNegociacao);
      const key = `${neg.getMonth() + 1}/${neg.getFullYear()}`;
      if (item.dataNegociacao && !months[key]) {
        months[key] = {
          mes: `${(neg.getMonth() + 1).toString().padStart(2, '0')}/${neg.getFullYear()}`,
          volume: []
        };
      }

      if(months[key])
        months[key].volume.push(item[fieldName]);        
    }
  });

  let dates = Object.values(months).map(e => e.mes);

  const data = Object.values(months).map(e => {
    let sum = 0;
    e.volume.forEach(cur => {
      sum += cur;
    });
    return sum === 0 ? null : sum;
  });

  return {
    dates,
    data
  };
}

const previstoConsumo = ({ funis, histoDates }) => {
  return accByField({arrayData: funis, fieldName: "volumeEstimado"});
  // const { startDate, endDate, dates } = defineDates({ funis });

  // const allDates = dates.concat(histoDates);

  // // Organizando as datas
  // let tempDates = {};

  // allDates.forEach(date => {
  //   if (!tempDates[date]) {
  //     tempDates[date] = [];
  //   }
  // });

  // funis.forEach(e => {
  //   if (e.status == "Ganha") {
  //     const { monthsBetween: between } = intervalBetweenDates({ startDate: new Date(e.inicioConsumo), endDate: new Date(e.fimConsumo) });
  //     const difMonths = between.length;

  //     const volume = e.volumeEstimado / difMonths;

  //     between.forEach(m => tempDates[m]?.push(volume));
  //   }
  // });

  // // Definindo o que será capturado
  // const curDate = new Date();
  // const dateKey = `${(curDate.getMonth() + 1).toString().padStart(2, '0')}/${curDate.getFullYear()}`;

  // const dateKeys = Object.keys(tempDates);
  // const centerIndex = dateKeys.indexOf(dateKey);
  // const initIndex = Math.max(centerIndex - 3, 0);
  // const endIndex = Math.min(centerIndex + 3, dateKeys.length - 1);

  // // Capturando os dados das datas selecionadas
  // const capturedIndex = {};
  // dateKeys.slice(initIndex, endIndex + 1).forEach(key => {
  //   capturedIndex[key] = tempDates[key];
  // });

  // tempDates = capturedIndex;

  // return {
  //   dates: Object.keys(tempDates),
  //   data: tempDates
  // };
};


const negociacoesFuturas = ({ funis }) => {
  let tempDates = {};
  funis.forEach(e => {
    if (e.dataNegociacao) {
      const currentDate = new Date(e.dataNegociacao);
      const customDate = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()}`;

      tempDates[customDate] ??= {
        itens: [],
        volumes: []
      }

      tempDates[customDate].itens.push(e);
      tempDates[customDate].volumes.push(e.volumeEstimado);
    }
  })

  return {
    dates: Object.keys(tempDates),
    data: tempDates
  }
}

function defineDates({ funis }) {
  let shortestMonth = "";
  let biggestMonth = "";

  funis.forEach(e => {
    if (e.ativo) {
      if (shortestMonth == "" || new Date(shortestMonth) > new Date(e.inicioConsumo))
        shortestMonth = e.inicioConsumo;

      if (biggestMonth == "" || new Date(biggestMonth) < new Date(e.fimConsumo))
        biggestMonth = e.fimConsumo;
    }
  })

  const { monthsBetween, startDate, endDate } = intervalBetweenDates({ startDate: new Date(shortestMonth), endDate: new Date(biggestMonth) })

  return {
    startDate,
    endDate,
    dates: monthsBetween
  }
}

function intervalBetweenDates({ startDate, endDate }) {
  startDate = startDate instanceof Date ? startDate : new Date(startDate);
  endDate = endDate instanceof Date ? endDate : new Date(endDate);
  let monthsBetween = [];
  let currentDate = new Date(startDate);

  endDate.setDate(1);
  currentDate.setDate(1);

  while (currentDate <= endDate) {
    monthsBetween.push(`${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()}`);
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return {
    monthsBetween,
    startDate,
    endDate
  };
}

